import { type Styles } from '@chakra-ui/theme-tools';

export const styles: Styles = {
  global: () => ({
    html: {
      bg: 'gray.50',
    },
    body: {
      WebkitTapHighlightColor: 'transparent',
      bg: 'white',
    },
    '#chakra-toast-portal > *': {
      pt: 'safe-top',
      pl: 'safe-left',
      pr: 'safe-right',
      pb: 'safe-bottom',
    },
    form: {
      display: 'flex',
      flexDir: 'column',
      flex: 1,
    },
  }),
};
